/**
 * Admin page rendered at "/admin/search" (nested route inside AdminHomepage, which is
 * mounted at "/admin/*" behind an admin-only ProtectedRoute). Manages the AI search
 * feature via a TabbedPage with four tabs: list ai bounties (AdminListViewContainer),
 * create an ai bounty (BountyCreateEdit), add search training data
 * (TrainingDataCreateDisplay), and browse existing search training data sets.
 */
import TabbedPage from "@/components/TabbedPage";
import BountyCreateEdit from "@/pages/bounty/BountyCreateEdit";
import AdminListViewContainer from "@/pages/admin/AdminListViewContainer";
import TrainingDataCreateDisplay from "@/pages/admin/ai/TrainingDataCreateDisplay";

const SearchAdminPage: React.FC = () => {
    return (
        <TabbedPage
            tabs={[
                {
                    tabName: "ai bounties",
                    render: () => (
                        <AdminListViewContainer key="ai-bounties" listItemType="ai_bounty" />
                    ),
                },
                {
                    tabName: "create ai bounty",
                    render: () => <BountyCreateEdit mode="create" type="ai" />,
                },
                {
                    tabName: "add training data",
                    render: () => <TrainingDataCreateDisplay type="search" mode="create" />,
                },
                {
                    tabName: "training data",
                    render: () => (
                        <AdminListViewContainer
                            key="search-training-data"
                            listItemType="search_training_data_set"
                        />
                    ),
                },
            ]}
        />
    );
};

export default SearchAdminPage;
